// extracted by mini-css-extract-plugin
export default {"container":"card_container__fCb66","content":"card_content__WPz7A","image_container":"card_image_container__3aU6B","image":"card_image__1kSDg"};